import axiosInstance from "@/axios/axiosInstance";
import { IApiError } from "@/interface/apiError.types";
import { parseApiError } from "@/lib/error-parser";
import type {
  PaymentMethodPayload,
  PaymentMethodResponse,
} from "@/interface/billing/paymentMethod.types";

export const createPaymentMethod = async (
  payload: PaymentMethodPayload
): Promise<PaymentMethodResponse> => {
  try {
    const res = await axiosInstance.post(
      `/subscription/payment-methods`,
      payload
    );
    return res?.data;
  } catch (error) {
    await parseApiError(error as IApiError);
    throw error;
  }
};
